import React, { useEffect } from 'react';
import { useSnackbar } from 'notistack';

import { useAppDispatch, useAppSelector } from '../../hooks';
import { SnackBar } from './SnackBarPopup';
import { appActions } from '../../redux/slices/appSlice';

let displayed: string[] = [];

export const SnackbarManager = () => {
    const dispatch = useAppDispatch();
    const { snackbarMessages } = useAppSelector((state) => state.app);
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();

    const storeDisplayed = (id: string) => {
        displayed = [...displayed, id];
    };

    const removeDisplayed = (id: string) => {
        displayed = [...displayed.filter((key) => id !== key)];
    };

    useEffect(() => {
        snackbarMessages.forEach(({ id, title, message, icon, iconColor, dismissed }) => {
            if (dismissed) {
                closeSnackbar(id);
                return;
            }

            if (displayed.includes(id)) {
                return;
            }

            enqueueSnackbar(message, {
                anchorOrigin: { vertical: 'top', horizontal: 'center' },
                key: id,
                content: (key, message) => (
                    <SnackBar
                        id={id}
                        message={message}
                        title={title}
                        icon={icon}
                        iconColor={iconColor}
                        onClose={() => dispatch(appActions.closeSnackbar(id))}
                    />
                ),

                onExited: () => {
                    dispatch(appActions.removeSnackbar(id));
                    removeDisplayed(id);
                },
            });

            storeDisplayed(id);
        });
    }, [snackbarMessages, displayed]);

    return null;
};
